import type { inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from 'config-hub-server/src/router/index.js';
import { fieldSpec } from './fields.js';
import type { EntityType } from './labels.js';

/** The server's own `EntityDetail['notCompared']` shape (`games.get`'s output — `service/matrix.ts`), inferred rather than redeclared. */
export type NotComparedEntry = inferRouterOutputs<AppRouter>['games']['get']['notCompared'][number];
export type NotComparedReason = NotComparedEntry['reason'];

/**
 * "why does the diff never mention `status`?" — answered on screen. Fields are grouped by
 * reason in the order they arrive, so the record's own field order survives and the reason is
 * stated once per run rather than once per field. Empty input is the empty string, so a caller
 * can render it unconditionally.
 */
export const notComparedSentence = (type: EntityType, rows: readonly NotComparedEntry[]): string => {
    if (rows.length === 0) return '';
    const groups: { reason: NotComparedReason; labels: string[] }[] = [];
    for (const row of rows) {
        const label = fieldSpec(type, row.field).label;
        const last = groups.at(-1);
        if (last && last.reason === row.reason) last.labels.push(label);
        else groups.push({ reason: row.reason, labels: [label] });
    }
    return `Not compared: ${groups.map((g) => `${g.labels.join(', ')} (${g.reason})`).join(', ')}`;
};
